import { UNLOCK_SUBMIT_EVT } from "./constants";

export function run(factor1,factor2,factor3,factor4,factor5,callback){
	// console.log(factor4);
	$.ajax({
			method: "post",
			url: "../php/run.php",
			async:true,
			data:"id="+factor1+"&level="+factor2+"&user="+factor3+"&interval="+factor4+"&unit="+factor5,
				success: function(r1, r2, r3){
					//console.log("rpa is success");
					//console.log(r1);
					callback();
					$(window).trigger(UNLOCK_SUBMIT_EVT);
					// return "success";
					//var json_object = $.parseJSON(r1);
					//$("#jobid").text(json_object["jobid"]);
				},
				error: function(r1){
					//console.log("rpa is fail");
					console.error(r1);
					$(window).trigger(UNLOCK_SUBMIT_EVT);
					return "fail";
				}
	});
}

export function run_compare(factor1,factor2,factor3,factor4,factor5,factor6,factor7,factor8,factor9,factor10, callback){
	// console.log("uid="+factor1+"&jobid="+factor2+"&intervaltime="+factor3+"&bootstrap="+factor4+"&namelist="+factor5+"&hc="+factor6+"&hd="+factor7+"&bal="+factor8+"&pve="+factor9);
	$.ajax({
		method: "post",
		url: "../php/run2.php",
		data:"uid="+factor1+"&jobid="+factor2+"&intervaltime="+factor3+"&bootstrap="+factor4+"&namelist="+factor5+"&hc="+factor6+"&hd="+factor7+"&bal="+factor8+"&pve="+factor9+"&timeunit="+factor10,
		success: function(r1, r2, r3){
			//console.log("rpa_compare is success");
			//console.log(r1);
			callback();
			$(window).trigger(UNLOCK_SUBMIT_EVT);
			return "success";
		},
		error: function(r1){
			console.error("rpa is fail:", r1);
			$(window).trigger(UNLOCK_SUBMIT_EVT);
			return "fail";
		}
	});
}
